import { Directive, inject, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[appStepHost]',
    standalone: true,
})
export class StepHostDirective {
    public viewContainerRef = inject(ViewContainerRef);
}
